// removed by extract-text-webpack-plugin
module.exports = {"root":"MenuLabel__root__3RWea","clickedWithMouse":"MenuLabel__clickedWithMouse__NGO5g","isOpen":"MenuLabel__isOpen__3uKVX"};


//////////////////
// WEBPACK FOOTER
// ./src/components/MenuLabel/MenuLabel.css
// module id = 2031
// module chunks = 0